export default __webpack_public_path__ + "static/media/71_mobile.1329270d.jpg";